export const FOLDER_NAME = 'name'

export const DUPLICATE_FILE_INITIAL_NOTIFICATION = 'selectFolderForDuplicate'
